<template>
  <div class="successPop" v-show="show">
    <img v-if="successPop.type == 'ok'" src="@assets/img/common/ok.svg" alt="ok">
    <img v-if="successPop.type != 'ok'" src="@assets/img/common/error.svg" alt="error">
    <p>{{successPop.msg}}</p>
  </div>
</template>

<script>
export default {
  name: 'equipmentLoan',
  data() {
    return {
      show: false,
      time: 3*1000,
      successPop: {
        type: 'ok',
        msg: '',
        tip: ''
      }
    }
  },
  methods: {
    open(d) {
      this.time = d.time || this.time
      this.successPop = {
        type: d.type || 'ok',
        msg: d.msg || ''
      }
      this.show = true
      this.close()
    },
    close() {
      setTimeout(() => {
        this.show = false
        this.successPop = {
          msg: '',
          tip: ''
        }
        
        window.close()
      }, this.time)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.successPop {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
    width: 200px;
    height: 150px;
    background-color: rgba(0, 15, 15, .8);
    border-radius: 8px;
    overflow: hidden;
    position: fixed;
    z-index: 1200;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    img {
      width: 30px;
      height: 30px;
      margin: 0 auto;
      display: block;
    }
    p {
      font-size: 16px;
      line-height: 22px;
      color: #fff;
      text-align: center;
      margin-top: 14px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-weight: bold;
      margin-top: 10px;
    }
    .msg {
      margin-top: 4px;
      font-size: 12px;
    }
  }
</style>
